/**
 * Focuses the first interactive element within a given jQuery container.
 *
 * Interactive elements include:
 * - Anchor tags (`<a>`)
 * - Button elements (`<button>`)
 * - Input fields (`<input>`)
 * - Select elements (`<select>`)
 * - Textarea elements (`<textarea>`)
 * - Any element with a `tabindex` attribute that is not `-1`
 *
 * @param {jQuery} $container - The jQuery object representing the container element.
 */
function focusFirstInteractiveElement($container) {
    if (!$container || $container.length === 0) {
        return;
    }

    const interactiveElementsSelector = "a, button, input, select, textarea, [tabindex]:not([tabindex=\"-1\"])";

    // Find all interactive elements within the container
    const $interactiveElements = $container.find(interactiveElementsSelector).filter(":visible");

    // Focus the first interactive element if it exists
    if ($interactiveElements.length > 0) {
        $interactiveElements.first().focus();
    }
}

/**
* Binds event handlers to tab elements for improved accessibility and keyboard navigation.
* When a tab is activated via keyboard (Enter key), focuses the first interactive element within the associated tab panel.
* @function
* @returns {void}
*/
function bindTabsEvents() {
    let tabActivatedByKeyboard = false;
    let $tabs = $(".nav-link[data-toggle='tab']");

    $tabs.on("shown.bs.tab", function (event) {
        if (tabActivatedByKeyboard) {
            const $selectedTab = $(event.target);
            const selectedID = $selectedTab.attr("aria-controls");
            const $selectedPanel = $("#" + selectedID);

            focusFirstInteractiveElement($selectedPanel);
        }

        tabActivatedByKeyboard = false;
    });

    $tabs.on("keydown", function(e) {
        if (e.key === "Enter") {
            tabActivatedByKeyboard = true;
        }
    });
}

module.exports = {
    init: bindTabsEvents()
};
